var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgInfoCircle = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Info Circle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333496 16.9988C0.333496 7.80049 7.80016 0.332153 17.0002 0.332153C26.2168 0.332153 33.6668 7.80049 33.6668 16.9988C33.6668 26.2005 26.2168 33.6655 17.0002 33.6655C7.80016 33.6655 0.333496 26.2005 0.333496 16.9988ZM15.5335 10.6822C15.5335 9.88382 16.2002 9.21549 17.0002 9.21549C17.8002 9.21549 18.4502 9.88382 18.4502 10.6822V18.0488C18.4502 18.8505 17.8002 19.4988 17.0002 19.4988C16.2002 19.4988 15.5335 18.8505 15.5335 18.0488V10.6822ZM17.0168 24.8005C16.2002 24.8005 15.5502 24.1338 15.5502 23.3338C15.5502 22.5338 16.2002 21.8838 17.0002 21.8838C17.8168 21.8838 18.4668 22.5338 18.4668 23.3338C18.4668 24.1338 17.8168 24.8005 17.0168 24.8005Z",
    fill: "#D29822"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfoCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/InfoCircle.b499d143.svg";
export { ForwardRef as ReactComponent };